function Brand() {
    return (
        <>
        <div className="py-32 mb-32">
            <div className="grid xl:grid-cols-2 grid-cols-1  gap-5">
                <div className="xl:col-span-2 max-w-2xl text-5xl font-mono py-20">New Doujin Merch</div>
                
                <div className="w-full h-80  md:rounded-full rounded-3xl hover:scale-90 duration-500">
                    <a href="/merch-memegoreng">
                    <div className="w-full h-full relative">
                        <img src ="/img/memegoreng.jpg" className="w-full h-full object-cover md:rounded-full rounded-3xl" alt="" />
                    </div>
                    </a>
                </div>
                <div className="w-full h-80 bg-rose-200 md:rounded-full rounded-3xl hover:scale-90 duration-500">
                    <a href="/merch-revue">
                    <div className="w-full h-full relative px-20 py-20">
                        <img src ="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Revue_Starlight_Logo.svg/2560px-Revue_Starlight_Logo.svg.png" className="w-full h-full object-scale-down" alt="" />
                    </div>
                    </a>
                </div>
                <div className="w-full h-80 bg-slate-200 md:rounded-full rounded-3xl hover:scale-90 duration-500">
                    <a href="/merch-shimeji">
                    <div className="w-full h-full relative px-5 py-5">
                        <img src ="https://hokagestorez.com/wp-content/uploads/2020/02/Everyday-Life-is-Strange-in-Shimeji-Simulation-Voice-Comic-Promo-Video.jpg" className="w-full h-full object-scale-down md:rounded-full rounded-3xl" alt="" />
                    </div>
                    </a>
                </div>
                <div className="w-full h-80 bg-slate-200 md:rounded-full rounded-3xl hover:scale-90 duration-500">
                    <a href="/merch-miku">
                    <div className="w-full h-full relative px-5 py-5">
                        <img src ="https://iconape.com/wp-content/png_logo_vector/hatsune-miku-logo-v3.png" className="w-full h-full object-scale-down " alt="" />
                    </div>
                    </a>
                </div>
                <div className="w-full h-80 bg-rose-50 md:rounded-full rounded-3xl hover:scale-90 duration-500">
                    <a href="/merch-nichijou">
                    <div className="w-full h-full relative px-20 py-20">
                        <img src ="https://media.vgm.io/products/36/2463/2463-1593937477.png" className="w-full h-full object-scale-down" alt="" />
                    </div>
                    </a>
                </div>
            </div>
        </div>
        </>
    )
}

export default Brand